import React,{useState,useEffect} from 'react';
import { 
  makeStyles,
   Typography,
   Grid,
   FormHelperText, 
   Table, 
   TableHead,
   TableRow,
   TableCell,
  withStyles, 
  TableBody,} from "@material-ui/core/";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import FormControl from '@material-ui/core/FormControl';
import { useSelector, useDispatch } from "react-redux";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { green ,red} from '@material-ui/core/colors';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {getTerms,
        getClasses,
        clearErrorStatusCode,
        getAttendaceReport,
        clearErrorMessage} from '../../../reduxSlices/attendaceSlice';
import Backdrop from "../../Backdrop";
import MessageIndicator from "../../SnackBar";
import { isObjectEmpty } from "../../../utils/general";
import { clearLoginData, isLoggedInUpdate } from "../../../reduxSlices/loginSlice";
import localizedStrings from '../../../utils/localize';
import Aux from "../../../hoc/Auxilliary";

const useStyle=makeStyles((theme)=>({
    heading:{
        fontSize: "1.8rem",
        fontWeight: 500,
    },
    formDesignMain: {
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        minHeight:"60vh",
        marginTop:"1rem"
      },
      formDesign: {
        width: "97%",
        margin: "0 auto",
      },
        formControl: {
          margin: theme.spacing(1),
          maxWidth: "30%",
        },
}))

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const AttendanceReport=(props)=>{
    const dispatch = useDispatch();
    const classes = useStyle(props);
    const [term,setTerms]=useState(0);
    const [classDate,setClassDate]=useState(0);
    const [className,setClassName]=useState(0);
    const [dates,setDates]=useState([]);
    const [error, setError] = useState({
        isError: false,
        message: "",
        showSnackbar: false,
      });
    const termsData=useSelector(state=> state.attendanceData.term);
    const classNameData=useSelector(state=> state.attendanceData.className);
    const classDateData=useSelector(state=> state.attendanceData.classDate);
    const applicantData = useSelector((state) => state.applicationData.applicantStatus.ses_applicantstatus );
    const attendanceReportData=useSelector(state=> state.attendanceData.attendanceReport);
    const [displayMessage,setDisplayMessage]=useState('')
    const dataFetchingStatus = useSelector(
      (state) => state.attendanceData.dataFetchingStatus
    );
    const errorMessage = useSelector(
      (state) => state.attendanceData.errorMessage
    );
    const errorStatusCode = useSelector(
      (state) => state.attendanceData.errorStatusCode
    );
 //current lagnguage
 const language =useSelector(state=> state.language.language);
 //set the current language to localize string
 localizedStrings.setLanguage(language);
 useEffect(()=>{
  localizedStrings.setLanguage(language);
 },[language]);

      const handleChange = (event) => {
        if(event.target.value){
          if(event.target.name ==="term"){
            setClassName(0)
            setClassDate(0)
            setTerms(event.target.value);
          }
          else if(event.target.name ==="className"){
            setClassDate(0)
            setClassName(event.target.value);
          }else if(event.target.name ==="classDate"){
            setClassDate(event.target.value);
          }

        }
        
      };

      useEffect(()=>{
        if(applicantData?.ses_applicantid !== undefined){
          dispatch(getTerms());
        }
       
      },[])
      useEffect(()=>{
        if(term !==0){
          dispatch(getClasses({
            query:"className",
            applicantId:applicantData.ses_applicantid,
            termId:term,
            type:'attendance'
          }));
        }
        
      },[term])
      useEffect(()=>{
        if(className !==0){
          dispatch(getClasses({
            query:"classDate",
            classId:className
          }));
        }
        
      },[className])
      useEffect(()=>{
        if(classDate !==0){
          dispatch(getClasses({
            query:"attendance",
            classDateId:classDate,
            classId:className,
            applicantId:applicantData.ses_applicantid,
          }));
        }
        
      },[classDate])
      useEffect(()=>{
        if(classDateData.length>0&& className!=0){
          dispatch(getAttendaceReport({classId:className}))
        }
      },[classDateData])


      const handelLogout = () => {
        dispatch(clearLoginData());
        window.localStorage.removeItem("x-auth-token");
        window.localStorage.removeItem("x-auth-fullname");
        window.localStorage.removeItem("x-auth-contactId");
        window.localStorage.removeItem("isUserLoggedIn");
        dispatch(isLoggedInUpdate(false));
        dispatch(clearErrorStatusCode());
        dispatch(clearErrorMessage());
        props.history.push("/login");
      };
    
      const handleClose = () => {
        let errorCopy = { ...error };
        errorCopy.showSnackbar = false;
        setError(errorCopy);
      };

      useEffect(() => {
        if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
          if (errorStatusCode === 401) {
            let error = {
              isError: false,
              message: `${localizedStrings.general.sessionexpired}`,
              showSnackbar: true,
            };
            setError(error);
            setTimeout(() => {
              handelLogout();
            }, 1600);
          } else {
            let error = {
              isError: false,
              message: errorMessage,
              showSnackbar: true,
            };
            setError(error);
          }
        }
      }, [errorMessage, errorStatusCode]);

      useEffect(()=>{
        if(classDateData.length>0){
          setDates([...classDateData].sort((a,b)=> new Date(a.ses_start).getTime() -new Date(b.ses_start).getTime()).map((date)=>{
            return  moment(date.ses_start).format('L');
          }))
        }
      },[classDateData]);
      let tableData= [];

      if(!isObjectEmpty(attendanceReportData)){
      
        tableData= Object.keys(attendanceReportData).map(atten=>{
          
          return (<StyledTableRow key={atten}>
            <StyledTableCell component="th" scope="row" align="center"> {attendanceReportData[atten].institutionstudentid} </StyledTableCell>
           <StyledTableCell component="th" align="center"> {attendanceReportData[atten].name} </StyledTableCell>
           {dates.map((date,index)=>{
            return  (
             <StyledTableCell  key={index} align="center"> {attendanceReportData[atten].dates[date]?<FiberManualRecordIcon style={{ color: green[500] }} />:<FiberManualRecordIcon style={{ color:red[500] }} />} </StyledTableCell>
           )
           })}
           <StyledTableCell> {attendanceReportData[atten].total}/{dates.length} </StyledTableCell>
       </StyledTableRow>)
        })
      }
  
      useEffect(() => {
        if (error.message === 'class id is required') {
          setDisplayMessage(localizedStrings.general.classiderrorMessage);
        }
        else if (error.message === "Invalid token") {
          setDisplayMessage(localizedStrings.general.invalidToken);
        } 
        else if (error.message === "Invalid request") {
          setDisplayMessage(localizedStrings.general.invalidRequest);
        } 
        else if (error.message === 'Something Went Wrong') {
          setDisplayMessage(localizedStrings.general.somethingwentwrong);
        }
        else{
          setDisplayMessage(error.message);
        }
      }, [error]);
  
    return(
      <Aux>
         <MessageIndicator
          open={error.showSnackbar}
          message={displayMessage}
          handleClose={handleClose}
        />
          <Backdrop show={dataFetchingStatus} />
            <Grid container item  className={classes.formDesignMain}>
                <Typography component="div" className={classes.heading}>
                {localizedStrings.facultyAndStuff.attendance.attendancereport}
                </Typography>
                <FormControl className={classes.formControl}>
                    <InputLabel id="term">{localizedStrings.facultyAndStuff.attendance.term}</InputLabel>
                    <Select
                    labelId="term"
                    id="term"
                    value={term}
                    name="term"
                    onChange={handleChange}
                    disabled={!applicantData}
                    >
                    <MenuItem value={0}>
                    <em>{localizedStrings.facultyAndStuff.attendance.selectOne} </em>
                   </MenuItem>
                   {termsData.length>0?(
                    termsData.map(el =>(
                      <MenuItem value={el.ses_termid}>{el.ses_termname}</MenuItem>
                    ))
                   ):null
                   }
                  </Select>
               </FormControl>   
               {term!==0?(
                   <FormControl className={classes.formControl}>
                    <InputLabel id="className">{localizedStrings.facultyAndStuff.attendance.className} </InputLabel>
                    <Select
                    labelId="className"
                    id="className"
                    value={className}
                    name="className"
                    onChange={handleChange}
                    >
                      <MenuItem value={0}>
                        <em>{localizedStrings.facultyAndStuff.attendance.selectOne}</em>
                        </MenuItem>
                      {
                      classNameData.length>0?(
                        classNameData.map(classData=>(
                        <MenuItem value={classData.ses_classid}>{classData.ses_coursename}</MenuItem>
                        ))
                      ):(
                        <FormHelperText>{localizedStrings.facultyAndStuff.attendance.NoClassNameMsg} </FormHelperText>
                       )
                    }
                    </Select>
                 </FormControl>
               ):null} 
               {className !==0 && classDateData.length>0?(
                 <>
                  <TableContainer
                    component={Paper}
                    style={{ minHeight: "40vh", marginBottom: "10px" }}
                    >
                    <Table aria-label="attendance report">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center">{localizedStrings.facultyAndStuff.attendance.studentid}</StyledTableCell>
                          <StyledTableCell align="center">Student Name</StyledTableCell>
                           {dates.map((date)=>{
                             return  (<StyledTableCell align="center">{date}</StyledTableCell>);
                           })}
                          <StyledTableCell align="center">Total</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          {tableData}
                      </TableBody>
                    </Table>
                  </TableContainer>
  
              </>
               ):null}
             
            </Grid>
        </Aux>
    )

}

export default withRouter(AttendanceReport);